import axios from "axios";
import { BN_APP } from "../../../constants/constant";
import { getAccessToken } from "../../../utils/okta-config";

export const getTransactionsForReviewAndApprove = async (userData, status) => {
  try {
    // Construct the UserDetailsDTO object from userData
    const userDetails = {
      userId: userData.userID, // Extract userID
      userRole: userData.userRole, // Extract userRole
      businessRole: userData.authorities || [], // Extract authorities
    };

    // Construct the request body
    const requestBody = {
      userDetails,
      status,
      pageType: "REVIEW_AND_APPROVE",
    };

    const response = await axios.post(`${BN_APP}/transaction/getTransactions`, requestBody, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`, // Ensure getAccessToken() returns a valid token
        "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT, // Ensure this is set correctly
        "Content-Type": "application/json", // Set content type to JSON
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const approveTransaction = async (billingDataIds) => {
  try {
    const response = await axios.post(`${BN_APP}/transaction/approveTransactions`, billingDataIds, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Content-Type": "application/json",
      },
    });

    return response.data; // Return the response data for further processing
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message); // Customize error message
  }
};

export const deleteTransaction = async (deleteTransactions) => {
  try {

    const response = await axios.delete(`${BN_APP}/transaction/deleteTransactions`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`, // Ensure getAccessToken() returns a valid token
        "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT, // Ensure this is set correctly
        "Content-Type": "application/json", // Set content type to JSON
      },
      data: deleteTransactions, // Pass the request body here
    });

    return response.data; // Return the response data for further processing
  } catch (error) {
    throw new Error(error.response?.message || error.message); 
  }
};

export const validateTransaction = async (transactionDetailsDto) => {
  try {
    const response = await axios.post(`${BN_APP}/transaction/validateTransactions`, transactionDetailsDto, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`, // Ensure getAccessToken() returns a valid token
        "Content-Type": "application/json", // Set content type to JSON
      },
    });
    return response.data; // Return the response data for further processing
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message); // Customize error message
  }
};

export const validateWithReferenceTransaction = async (transactionDetailsDto) => {
  try {
    const response = await axios.post(`${BN_APP}/transaction/validateWithReferenceTransaction`, transactionDetailsDto, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getWithReferenceTransactions = async (user, status = "ERROR") => {
  try {
    const payload = {
      userDetails: {
        userId: user.userID,
        userRole: user.userRole,
        businessRole: user.businessRole,
      },
      status: status,
    };
    
    const response = await axios.post(
      `${BN_APP}/transaction/getWithReferenceTransactions`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getConditionTypes = async () => {
  try {
    const response = await axios.get(
      `${BN_APP}/billing-data/condition-types`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const approveWithReferenceTransaction = async (billingDataId, userData) => {
  try {
    const userDetails = {
      userId: userData.userID,
      userRole: userData.userRole,
      businessRole: userData.businessRoles,
    };

    const requestBody = {
      billingDataId,
      userDetails,
    };

    console.log("=== Approving With-Reference Transaction ===");
    console.log("BillingDataId:", billingDataId);
    console.log("UserId:", userData.userID);

    const response = await axios.post(
      `${BN_APP}/transaction/approveWithReferenceTransaction`, 
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error approving with-reference transaction:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

